'use client';

import { Flex, Text, Button, Span } from '@mezzoforte/forge';
import { NextLinkButton } from '@/components/Link/LinkButton';
import { useLoginModal } from '@/hooks/useLoginModal';

export function BiddingLoginNotification() {
  const { openLoginModal, LoginModal } = useLoginModal();
  return (
    <Flex
      flexDirection="column"
      mt={3}
      p={3}
      backgroundColor="backgroundGray"
      justify="space-between"
    >
      <Text m={1}>Kirjaudu sisään, jotta voit huutaa </Text>
      <Flex mt={2}>
        <Button
          flexGrow={1}
          px={2}
          mr={1}
          fontSize="sm"
          variant="highlight"
          onClick={openLoginModal}
        >
          Kirjaudu sisään
        </Button>
        <Span
          flexGrow={1}
          ml={1}
        >
          <NextLinkButton
            w="100%"
            fontSize="sm"
            href="/tee-tunnus"
            textAlign="center"
          >
            Tee tunnus
          </NextLinkButton>
        </Span>
      </Flex>
      <LoginModal />
    </Flex>
  );
}
